import axios from "axios";
import { USER_LOADING, USER_LOADED, AUTH_ERROR } from "./types";
import axiosConfig from "../axiosConfig";

export const tokenConfig = (getState) => {
  // GET token rom state
  const token = getState().auth.token;

  // Headers
  const config = {
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
    },
  };

  // If token, add to headers config
  if (token) {
    config.headers["auth-token"] = `${token}`;
  }

  return config;
};

// CHECK TOKEN & LOAD USER
export const loadUser = () => (dispatch, getState) => {
  // USER Loading
  dispatch({ type: USER_LOADING });

  axios
    .get(`${axiosConfig.baseUrl}/verify`, tokenConfig(getState))
    .then((res) => {
      dispatch({
        type: USER_LOADED,
        payload: res.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: AUTH_ERROR,
      });
    });
};
